/**
 * ## Component manager component
 *
 * @module src/components/component
*/

'use strict';

const conf = require('../../config');
const dropdown = require('../dropdown');
const buttonlist = require('../buttonlist');
const calendar = require('../calendar');
const time = require('../time');
const size = require('../size');
const block = require('../block');
const accordion = require('../accordion');
const listsort = require('../listsort');
const tableedit = require('../tableedit');

/**
 * Component display.
 */
const create = (options, data, callback) => {
    let delay = 1;
    if ($('input:focus').attr('type') === 'text') {
        document.activeElement.blur();
        $('input').blur();
        if (conf.vars.NODE_ENV.indexOf('android') > -1) {
            delay = 100;
        }
    }
    setTimeout(() => {
        const target_id = options.target_id;
        const type = options.type;
        let position = options.position;
        $('#component_catch').css('display', 'block');

        $('#component_dropdown').css('display', 'none');
        $('#component_calendar').css('display', 'none');
        $('#component_time').css('display', 'none');
        $('#component_size').css('display', 'none');
        $('#component_block').css('display', 'none');
        $('#component_accordion').css('display', 'none');
        $('#component_listsort').css('display', 'none');
        $('#component_tableedit').css('display', 'none');
        $('#component_buttonlist').css('display', 'none');
        $('#component_guide').css('display', 'none');

        $('#component_arrow_top').css('display', 'none');
        $('#component_arrow_bottom').css('display', 'none');
        $('#component_arrow_left').css('display', 'none');
        $('#component_arrow_right').css('display', 'none');

        $(`#component_${type}`).css('display', 'inline-block');

        // notes for later. convert all componts to opt, data, callback format.
        switch (type) {
        case 'dropdown': {
            const opt = {
                target_id: 'component_dropdown',
                highlight: options.highlight,
            };
            dropdown.create(opt, data, callback);
            break;
        }
        case 'buttonlist': {
            const opt = {
                target_id: 'component_buttonlist',
                highlight: options.highlight,
            };
            buttonlist.create(opt, data, callback);
            break;
        }
        case 'calendar': {
            const opt = {
                target_id: 'component_calendar',
                allowPast: options.allowPast,
                hightlight: options.highlight,
                startDate: options.startDate,
                kd: options.kd,
                nodestroy: options.nodestroy,
            };
            calendar.create(opt, data, callback);
            break;
        }
        case 'time': {
            if (!options.hasOwnProperty('start')) {
                options.start = 80;
            }
            const opt = {
                target_id: 'component_time',
                start: options.start,
                date: options.date,
                location: options.location,
                availability: options.availability,
            };
            time.create(opt, data, callback);
            break;
        }
        case 'size': {
            const opt = {
                target_id: 'component_size',
                targetResult: options.targetResult,
            };
            size.create(opt, data, callback);
            break;
        }
        case 'block': {
            const opt = {
                kd: options.kd,
                target_id: 'component_block',
                confirmation: options.confirmation,
            };
            block.create(opt, data, callback);
            break;
        }
        case 'accordion': {
            const opt = {
                target_id: 'component_accordion',
                mode: options.mode,
                kd: options.kd,
            };
            accordion.create(opt, data, callback);
            break;
        }
        case 'listsort': {
            const opt = {
                target_id: 'component_listsort',
                mode: options.mode,
            };
            listsort.create(opt, data, callback);
            break;
        }
        case 'tableedit': {
            const opt = {
                target_id: 'component_tableedit',
                tabletype: options.tabletype,
            };
            tableedit.create(opt, data, callback);
            break;
        }
        default: {
            break;
        }
        }

        let adjustX = 0;
        let adjustY = 0;

        if (options.adjust !== undefined) {
            adjustX = options.adjust.x;
            adjustY = options.adjust.y;
        }
        let componentX = $(`#${target_id}`).offset().left + adjustX;
        const componentY = $(`#${target_id}`).offset().top + adjustY;
        const componentHeight = $('#component').outerHeight();
        const componentWidth = $('#component').outerWidth();
        const targetHeight = $(`#${target_id}`).outerHeight();
        const targetWidth = $(`#${target_id}`).outerWidth();

        const componentOffset = ($('#component').outerHeight() - $(`#${target_id}`).outerHeight())
            / 2;

        let componentEdgeOffset = 0;
        if (componentY - componentOffset < 0) {
            componentEdgeOffset = componentY - componentOffset;
        }
        if (componentY + componentOffset > conf.vars.viewportHeight) {
            componentEdgeOffset = componentY + componentOffset + targetHeight -
                conf.vars.viewportHeight;
        }

        if (!position) {
            position = 'left';
        }
        // calculator off screen offsets
        if (position === 'top' && $(`#${target_id}`).offset().top - componentHeight < 0) {
            position = 'bottom';
        }
        if (position === 'bottom' &&
            $(`#${target_id}`).offset().top + componentHeight > conf.vars.viewportHeight) {
            position = 'top';
        }
        if (position === 'left' &&
            $(`#${target_id}`).offset().left - componentWidth < 0) {
            position = 'right';
        }
        if (position === 'right' &&
            $(`#${target_id}`).offset().left + $(`#${target_id}`).outerWidth() + componentWidth >
            conf.vars.viewportWidth) {
            if (options.hasOwnProperty('forcePosition') && options.forcePosition) {
                // $(`#${target_id}`).offset().left + adjustX;
            } else {
                position = 'left';
                componentX = $(`#${target_id}`).offset().left + adjustX / 5;
            }
        }

        if (position === 'left' && componentX < 380) {
            componentX = 380;
        }

        switch (position) {
        case 'bottom':
            $('#component_arrow_top').css('display', 'block');
            TweenMax.set('#component', {
                transformOrigin: '0% 0%',
            });
            TweenMax.to('#component', 0, {
                x: componentX,
                y: componentY + targetHeight,
            });
            $('#component_catch').css('display', 'block');
            break;
        case 'top':
            $('#component_arrow_bottom').css('display', 'block');
            TweenMax.set('#component', {
                transformOrigin: '0% 100%',
            });
            TweenMax.to('#component', 0, {
                x: componentX,
                y: componentY - componentHeight,
            });
            $('#component_catch').css('display', 'block');
            break;
        case 'right':
            $('#component_arrow_left').css('display', 'block');
            $('#component_arrow_left').css('margin-top', componentOffset + componentEdgeOffset
                - 15);
            TweenMax.set('#component', { transformOrigin: '100% 100%' });
            TweenMax.to('#component', 0, {
                x: componentX + targetWidth + 4,
                y: componentY - componentOffset - componentEdgeOffset,
            });
            $('#component_catch').css('display', 'block');
            break;
        case 'left':
            $('#component_arrow_right').css('display', 'block');
            $('#component_arrow_right').css('margin-top', componentOffset + componentEdgeOffset
                - 15);
            TweenMax.set('#component', {
                transformOrigin: '100% 100%',
            });
            TweenMax.to('#component', 0, {
                x: componentX - componentWidth - 4,
                y: componentY - componentOffset - componentEdgeOffset,
            });
            $('#component_catch').css('display', 'block');
            break;
        default:
        }

        $('#component_catch').off();
        $('#component_catch').fastClick((e) => {
            if (document.activeElement.id === 'tableNumberEdit') {
                document.activeElement.blur();
                $('input').blur();
            }
            // e.preventDefault();
            // event.stopImmediatePropagation();
            // event, type, data to create component, return value to populate
            destroy();
        });
    }, delay);
};

const destroy = () => {
    $('#component_arrow_top').html('');
    $('#component_arrow_left').html('');
    $('#component_dropdown').html('');
    $('#component_calendar').html('');
    $('#component_time').html('');
    $('#component_size').html('');
    $('#component_block').html('');
    $('#component_accordion').html('');
    $('#component_listsort').html('');
    $('#component_tableedit').html('');
    $('#component_buttonlist').html('');
    $('#component_arrow_right').html('');
    $('#component_arrow_bottom').html('');
    $('#component_catch').css('display', 'none');
};

module.exports = {
    create,
    destroy,
};




/** WEBPACK FOOTER **
 ** ./src/components/component/index.js
 **/